'use client';

import { useEffect } from 'react';
import { ArticleView, type Article } from './ArticleView';
import type { AuthorDocument } from '../../../prismicio-types';

interface ArticlePageWrapperProps {
  article: Article;
  author: Partial<AuthorDocument>;
  imageLayout?: 'cover' | 'fill';
}

/**
 * Client-side wrapper for `ArticleView` that sets the `read_id` cookie for the
 * "You may also like" related-posts feature. Same behavior for blog posts and
 * webinar posts — the related-posts widget queries by the read id regardless
 * of the source type.
 */
export function ArticlePageWrapper({
  article,
  author,
  imageLayout,
}: ArticlePageWrapperProps) {
  useEffect(() => {
    if (article?.id) {
      document.cookie = `read_id=${article.id}; max-age=${60 * 60 * 24}; path=/; samesite=lax`;
    }
  }, [article?.id]);

  return (
    <ArticleView article={article} author={author} imageLayout={imageLayout} />
  );
}
